import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { qualtrics } from '@uhg-abyss/web/tools/event/listeners/qualtrics';
import { adobeAnalytics } from '@uhg-abyss/web/tools/event/listeners/adobeAnalytics';
import { qualtricsTags } from './tags/qualtrics';
import { adobeTags } from './tags/adobe';
import { elasticApmAnalytics } from './elasticApm';
import { elasticApmTags } from './tags/elasticApm';

export const registerAnalytics = (data) => {
  event.listener(
    adobeAnalytics({
      id: 'adobe-analytics-epv',
      enabled: config('ANALYTICS_TRACKING'),
      logging: config('ANALYTICS_LOGGING'),
      events: adobeTags,
      metadata: data,
    })
  );
  event.listener(
    elasticApmAnalytics({
      id: 'elastic-apm',
      enabled: true,
      logging: true,
      events: elasticApmTags,
      metadata: data,
    })
  );

  event.listener(
    qualtrics({
      id: 'qualtrics-epv',
      url: config('QUALTRICS_SURVEY_SCRIPT'),
      logging: config('ANALYTICS_LOGGING'),
      enabled: true,
      events: qualtricsTags,
      metadata: data,
    })
  );
};
